import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import * as Yup from "yup";
import Button from "@mui/material/Button";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { signIn } from "../../apiCalls/userApiCalls";
import { errNotification, successNotification } from "../common/notification";
import { Modal } from "@mui/material";
import ForgetPasswordDialog from "./ForgotPasswordForm";

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        S2A Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const theme = createTheme();

export default function SignInSection() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const validationSchema = Yup.object().shape({
    password: Yup.string().min(4).required("Please is required"),
    email: Yup.string().email("Email is invalid").required("Email is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const payload = {
          email: values.email,
          password: values.password,
        };
        setLoading(true);
        signIn(payload, dispatch)
          .then((res) => {
            setLoading(false);
            successNotification("Login Success!!!");
            setTimeout(() => {
              navigate("/");
            }, 3000);
          })
          .catch((err) => {
            setLoading(false);
            errNotification("Login Failed!!!");
          });
        resetForm();
      } catch (error) {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <ToastContainer />
      <CssBaseline />
      <Container component="main" maxWidth="sm">
        <Paper
          variant="outlined"
          sx={{
            my: { xs: 3, md: 6 },
            p: { xs: 2, md: 3 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            sx={{
              height: "130px",
              width: "250px",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            src="https://firebasestorage.googleapis.com/v0/b/s2a-e8459.appspot.com/o/assets%2Fphoto_2023-03-28%2017.16.55.jpeg?alt=media&token=a06939a3-722b-4c5c-968d-f58891020238"
            alt="random"
          ></Box>

          <React.Fragment>
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <React.Fragment>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                      <TextField
                        id="email"
                        label="Email"
                        fullWidth
                        variant="standard"
                        name="email"
                        autoCapitalize="off"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                      />
                      <ErrorMessage name="email">
                        {(msg) => (
                          <div
                            style={{
                              color: "red",
                              textAlign: "left",
                              fontSize: "12px",
                            }}
                          >
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        id="password"
                        label=" Password"
                        fullWidth
                        variant="standard"
                        type="password"
                        name="password"
                        autoComplete="off"
                        onChange={formik.handleChange}
                        value={formik.values.password}
                      />
                      <ErrorMessage name="password">
                        {(msg) => (
                          <div
                            style={{
                              color: "red",
                              textAlign: "left",
                              fontSize: "12px",
                            }}
                          >
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </Grid>
                  </Grid>

                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      variant="contained"
                      sx={{ mt: 3, ml: 1 }}
                      width="100px"
                      type="submit"
                      disabled={loading}
                    >
                      Login
                    </Button>
                  </Box>
                  <Link variant="body2" onClick={handleOpen}>
                    forgot password ?
                  </Link>
                </React.Fragment>
              </Form>
            </FormikProvider>
          </React.Fragment>
        </Paper>
        <Copyright />
        <Modal
          keepMounted
          open={open}
          onClose={handleClose}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={style}>
            <ForgetPasswordDialog />
          </Box>
        </Modal>
      </Container>
    </ThemeProvider>
  );
}
